import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, CardMedia, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import {
	Root,
	SlideUp,
	StyledTypographhheroheanding,
	TextContainer,
} from '../../components/component/ThemeComponent';
import '../common/page/Homepage/Heroheader.css'; // Import the CSS file for animations

interface BannerProps {
	asideImage: string;
	smallTitle: string;
	headerContent: string;
	paraContent: string;
}

const ReUsableBanner: React.FC<BannerProps> = ({
	asideImage,
	smallTitle,
	headerContent,
	paraContent,
}) => {
	// Get the current pathname from the window location
	const currentPath = window.location.pathname;
	const navigate = useNavigate();
	const handleExploreMenuClick = () => {
		navigate('/customized-menu'); // Navigate to the /menu route
	};

	return (
		<Root>
			<Grid
				container
				spacing={2}
				direction="row"
				justifyContent="center"
				alignItems="center"
				sx={{ height: '100%' }}
			>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
					<TextContainer
						sx={{ marginLeft: { lg: '38%' }, padding: { xs: '5px 20px', lg: '0px' } }}
					>
						<SlideUp style={{ animationDelay: '0.2s' }}>
							<Typography
								color="primary"
								variant="body1"
								fontWeight={700}
								gutterBottom
								width={'inherit'}
							>
								<Typography variant="overline" fontSize={'23.25px'}>
									-
								</Typography>{' '}
								{smallTitle}{' '}
								<Typography variant="overline" fontSize={'23.25px'}>
									-
								</Typography>
							</Typography>
						</SlideUp>
						<SlideUp style={{ animationDelay: '0.2s' }}>
							<StyledTypographhheroheanding
								variant="h3"
								gutterBottom
								className="letter-animation"
								sx={{
									color: 'black',
									fontSize: { xs: '24px', sm: '32px', md: '33.58px' },
									fontWeight: '900',
								}}
							>
								{headerContent}
							</StyledTypographhheroheanding>
						</SlideUp>
						<SlideUp style={{ animationDelay: '0.3s' }}>
							<Typography
								variant="body1"
								className="letter-animation"
								sx={{
									fontFamily: 'Montserrat',
									color: '#515151',
									fontSize: '12px',
									fontWeight: '700',
								}}
							>
								{paraContent}
							</Typography>
						</SlideUp>
						{/* Conditionally render the button based on the current path */}
						{currentPath !== '/menu' && (
							<SlideUp style={{ animationDelay: '0.4s' }}>
								<Button
									variant="contained"
									className="letter-animation"
									color="primary"
									sx={{
										marginTop: '1rem',
									}}
									onClick={handleExploreMenuClick}
								>
									Explore our Menu
								</Button>
							</SlideUp>
						)}
					</TextContainer>
				</Grid>
				<Grid
					size={{ lg: 6 }}
					sx={{
						display: { xs: 'none', md: 'none', lg: 'block' },
						height: 'inherit',
						position: 'relative',
					}}
				>
					<CardMedia
						component="img"
						image={asideImage}
						alt="hero-image"
						sx={{
							width: '100%',
							height: 'inherit',
						}}
					/>
				</Grid>
			</Grid>
		</Root>
	);
};

export default ReUsableBanner;
